import React from 'react';
import { Size } from '../../../core/enums/Size';

import './TextArea.scss';

interface Props {
  label?: string;
  id: string;
  name: string;
  error?: string;
  errorTextVisible?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  value: string;
  labelSize?: Size;
  formatting?: (value: string) => string | number | undefined;
  className?: string;
  placeholder?: string;
  required?: boolean;
  maxLength?: number;
}

const TextArea: React.FC<Props> = ({
  label,
  error,
  id,
  name,
  onChange,
  onBlur,
  value,
  labelSize,
  formatting,
  className,
  errorTextVisible = true,
  placeholder,
  required,
  maxLength
}) => {
  const [isFocused, setFocused] = React.useState(false);
  return (
    <div className={`text-area ${error ? 'text-area--error' : ''} ${className ?? ''}`}>
      {label && (
        <label className={`text-area__label ${labelSize ? `text-area__label--${labelSize}` : ''}`} htmlFor={id}>
          {label}
          {required && '*'}
        </label>
      )}
      <textarea
        className="text-area__input"
        value={!isFocused && formatting ? formatting(value) : value}
        id={id}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={() => {
          setFocused(true);
        }}
        onBlur={(e) => {
          setFocused(false);
          if (onBlur) {
            onBlur(e);
          }
        }}
        required={required}
        maxLength={maxLength}
      />
      {errorTextVisible && error && <div className="text-area__error">{error}</div>}
    </div>
  );
};

export default TextArea;
